import { Icon } from '@udemy/icons';
import { IconButton } from '@udemy/react-core-components';
import classNames from 'classnames';
import React from 'react';
import styles from "./dialog-close-button.module.css";
/** React props interface for the `DialogCloseButton` component. */

/** The DialogCloseButton component. */
export const DialogCloseButton = _ref => {
  let {
    className,
    id,
    label
  } = _ref;
  return /*#__PURE__*/React.createElement(IconButton, {
    className: classNames(styles['close-btn'], className),
    "data-purpose": "close-btn",
    cssToggleId: id,
    round: true,
    udStyle: "white-solid",
    "aria-label": label
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "close",
    color: "neutral",
    label: false
  }));
};
//# sourceMappingURL=dialog-close-button.react-component.js.map